import React from 'react';
import styled from 'styled-components';
import {fontSize, outlineColor, wh} from '../mixins';

const StyledLabel = styled.label`
 width: 100%;
 font-weight: 600;
 ${fontSize(16)};
 line-height: 22px;
 letter-spacing: -0.41px;
 color: #323232;
`
const StyledInput = styled.input`
  ${wh('100%', '48px')};
  font-weight: 500;
  ${fontSize(16)};
  line-height: 22px;
  letter-spacing: -0.41px;
  color: #323232;
  border: 1px solid #D4D4D4;
  border-radius: 4px;
  margin-top: 10px;
  padding: 14px 16px;
  
  &:focus {
    outline-color: ${outlineColor};
  }
  
  &::placeholder {
    color: #848484;
    font-weight: 300;
  }
  
`


const Input = ({label, type, value, onChange, placeholder}) => (
    <StyledLabel>{label}
        <StyledInput type={type} value={value} onChange={onChange} placeholder={placeholder}/>
    </StyledLabel>
);

export default Input;